import { create } from 'zustand';
import { CreatorPlatformsType } from '~/clientApi';
import {
  ConnectedPlatformsType,
  getConnectedPlatforms,
} from '~/screens/ManagePlatforms';
import { ICreator } from '~/types';

export interface Props {
  isModalOpen: boolean;
  creator: ICreator | undefined;
  connectedPlatforms: ConnectedPlatformsType[];
  closeModal: () => void;
  openModal: () => void;
  showPlatforms: (creator: ICreator | undefined) => void;
}

export const useEditPlatformsStore = create<Props>((set) => ({
  isModalOpen: false,
  creator: undefined,
  connectedPlatforms: [],
  closeModal: () => set(() => ({ isModalOpen: false })),
  openModal: () => set(() => ({ isModalOpen: true })),
  showPlatforms: (creator) =>
    set(() => {
      const connectedPlatforms = getConnectedPlatforms(
        creator?.platforms as CreatorPlatformsType,
        creator?.isOffPlatform,
      );
      return { creator, connectedPlatforms, isModalOpen: true };
    }),
}));
